// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import VideoModal from '../../home/components/Discover/VideoModal';

import Testimonial from '../../../elements/CarouselTestimonials/Testimonial/Testimonial';

import style from './Testimonials.scss';
import lolo from '../../../assets/img/testimonials/lolo.png';
import tere from '../../../assets/img/testimonials/Tere.png';
import silvana from '../../../assets/img/testimonials/silvana.png';
import ana from '../../../assets/img/testimonials/ana.png';
import franz from '../../../assets/img/testimonials/franz.png';
import gino from '../../../assets/img/testimonials/gino.png';
import marjorie from '../../../assets/img/testimonials/Marjorie.png';

import type { TestimonialItem } from '../../../elements/CarouselTestimonials/Testimonial/Testimonial';

type Props = {};

type State = {
  videoUrl: string;
  modalVisible: boolean;
};

export const travelersTestimonials: TestimonialItem[] = [
  {
    image: tere,
    name: 'Teresa Becerra',
    location: 'Lima, Perú',
    textIntl: 'newFlight.testimonial.second.text',
    video: 'https://www.youtube.com/embed/KY7xujXQiCI?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
    flight: {
      departure: 'Miami',
      arrival: 'Lima',
    },
  },
  {
    image: silvana,
    name: 'Silvana Campos',
    location: 'Trujillo, Perú',
    textIntl: 'newFlight.testimonial.third.text',
    video: 'https://www.youtube.com/embed/xSXtfWs7F1w?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
    flight: {
      departure: 'California',
      arrival: 'Lima',
    },
  },
  {
    image: marjorie,
    name: 'Marjorie',
    location: '',
    textIntl: 'newFlight.testimonial.four.text',
    video: 'https://www.youtube.com/embed/_bGS_eOlXks?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
    flight: {
      departure: 'Miami',
      arrival: 'Lima',
    },
  },
  {
    image: ana,
    name: 'Ana',
    location: '',
    textIntl: 'newFlight.testimonial.five.text',
    video: 'https://www.youtube.com/embed/xpe09U2-_rU?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
    flight: {
      departure: 'Miami',
      arrival: 'Lima',
    },
  },
  {
    image: gino,
    name: 'Gino',
    location: '',
    textIntl: 'newFlight.testimonial.six.text',
    video: 'https://www.youtube.com/embed/JK761-Utj0s?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
    flight: {
      departure: 'California',
      arrival: 'Lima',
    },
  },
  {
    image: franz,
    name: 'Franz',
    location: '',
    textIntl: 'newFlight.testimonial.seven.text',
    video: 'https://www.youtube.com/embed/RHj_QfhsSJ4?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
    flight: {
      departure: 'Nueva York',
      arrival: 'Lima',
    },
  },

];

export default class TravelerTestimonials extends Component<Props, State> {
  state = {
    videoUrl: '',
    modalVisible: false,
  };

  handleOpenModal = (videoUrl: string) => {
    this.setState({ modalVisible: true, videoUrl });
  };

  handleCloseModal = () => {
    this.setState({ modalVisible: false });
  };

  render() {
    const { videoUrl, modalVisible } = this.state;
    return (
      <Fragment>
        <section className={style.travelersWrap}>
          <FormattedMessage id="testimonials.travelers.title">{
            txt => <h1>{txt}</h1>
          }</FormattedMessage>
          {travelersTestimonials.map((item: TestimonialItem, n: number) =>
            <article key={n} className={style.testimonialWrap}>
              <Testimonial handleClick={this.handleOpenModal.bind(this/*, item.video*/)}
                           userType="traveler"
                           item={item}/>
            </article>)}
        </section>
        <VideoModal handleClose={this.handleCloseModal}
                    modalVisible={modalVisible}
                    url={videoUrl}/>
      </Fragment>
    );
  }
}

TravelerTestimonials.propTypes = {};



// WEBPACK FOOTER //
// ./src/modules/testimonials/components/TravelerTestimonials.jsx